export default __webpack_public_path__ + "static/media/4.5b681084.png";